import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b27011b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4b27011b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27011b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b27011b')) {
      api.createRecord('4b27011b', component.options)
    } else {
      api.reload('4b27011b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b27011b&scoped=true", function () {
      api.rerender('4b27011b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settlement/bank-account/index.vue"
export default component.exports